import { render } from "./projectCooperative.vue?vue&type=template&id=4b16c962&scoped=true"
import script from "./projectCooperative.vue?vue&type=script&lang=js"
export * from "./projectCooperative.vue?vue&type=script&lang=js"

import "./projectCooperative.vue?vue&type=style&index=0&id=4b16c962&scoped=true&lang=less"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b16c962"]])

export default __exports__